import { Record } from "../../../../fable_modules/fable-library-js.4.19.3/Types.js";
import { DeviceOptionsViewModel_$reflection } from "../../../../RAWMap.Models/View/DeviceOptions.js";
import { record_type } from "../../../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { AsyncResultComputationExpression_asyncResult, AsyncResultComputationExpression_AsyncResultBuilder__Return_1505, AsyncResultComputationExpression_AsyncResultBuilder__Bind_454FBA93, AsyncResultComputationExpression_AsyncResultBuilder__Delay_Z5276B41B } from "../../../../fable_modules/AsyncResult.0.3.0/Result.fs.js";
import { Shared_footer, Shared_headerHeight, Shared_header } from "./SharedSection.js";
import { isNullOrWhiteSpace } from "../../../../fable_modules/fable-library-js.4.19.3/String.js";
import { Pdf_Table_Style, Pdf_Table_Adv_make, Pdf_Spacing_narrowSpacingY, Pdf_Spacing_leftMargin, Pdf_Autotable, Pdf_JsPdf } from "../ReportPdfHelpers.js";
import { Shared_ptToMm } from "../../../../Visualization/VisualizationShared.js";

export class Args extends Record {
    constructor(devices) {
        super();
        this.devices = devices;
    }
}

export function Args_$reflection() {
    return record_type("RAWMap.Client.Study.CustomStentReport.ReportPdf.Sections.StudyInfoSection.Args", [], Args, () => [["devices", DeviceOptionsViewModel_$reflection()]]);
}

export function create(doc, headerArgs, args) {
    return AsyncResultComputationExpression_AsyncResultBuilder__Delay_Z5276B41B(AsyncResultComputationExpression_asyncResult, () => AsyncResultComputationExpression_AsyncResultBuilder__Bind_454FBA93(AsyncResultComputationExpression_asyncResult, Shared_header(headerArgs, doc), (_arg) => {
        let copyOfStruct_1, copyOfStruct_2;
        const headerHeaderRow = [["Sizing", "Trunk", "Contralateral", "Additional Left", "Additional Right"]];
        const placeholderIfEmpty = (s) => {
            if (isNullOrWhiteSpace(s)) {
                return "--";
            }
            else {
                return s;
            }
        };
        const headerTableRows = [["Ipsilateral-Right", placeholderIfEmpty(args.devices.ipsilateralRight.trunk), placeholderIfEmpty(args.devices.ipsilateralRight.contralateral), placeholderIfEmpty(args.devices.ipsilateralRight.additionalLeft), placeholderIfEmpty(args.devices.ipsilateralRight.additionalRight)], ["Ipsilateral-Left", placeholderIfEmpty(args.devices.ipsilateralLeft.trunk), placeholderIfEmpty(args.devices.ipsilateralLeft.contralateral), placeholderIfEmpty(args.devices.ipsilateralLeft.additionalLeft), placeholderIfEmpty(args.devices.ipsilateralLeft.additionalRight)]];
        const jsPDF = Pdf_JsPdf.jsPDF;
        Pdf_Autotable.applyPlugin(jsPDF);
        let previousFont;
        let copyOfStruct = doc;
        previousFont = copyOfStruct.getFontSize();
        (copyOfStruct_1 = doc, copyOfStruct_1.setFontSize(12));
        const titleHeight = Shared_ptToMm((copyOfStruct_2 = doc, copyOfStruct_2.getLineHeight()));
        let doc_1;
        let copyOfStruct_3 = doc;
        doc_1 = copyOfStruct_3.text("Stent Device Option", Pdf_Spacing_leftMargin, Shared_headerHeight + Pdf_Spacing_narrowSpacingY);
        doc_1.setFontSize(previousFont);
        return AsyncResultComputationExpression_AsyncResultBuilder__Bind_454FBA93(AsyncResultComputationExpression_asyncResult, Shared_footer(Pdf_Table_Adv_make({
            body: headerTableRows,
            head: headerHeaderRow,
            startY: (Shared_headerHeight + titleHeight) + 2,
            styles: Pdf_Table_Style,
        }, _arg)), (_arg_1) => AsyncResultComputationExpression_AsyncResultBuilder__Return_1505(AsyncResultComputationExpression_asyncResult, _arg_1));
    }));
}

